<div class="container-fluid-boxed">
  <div class="row">
    <div class="col-md-12">
      <app-company-ranks-carousel></app-company-ranks-carousel>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-md-12">
      <mat-progress-bar
        mode="indeterminate"
        *ngIf="isLoading"></mat-progress-bar>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-3 order-sm-2">
      <ng-container *ngIf="firstSpotlightNews$ | async as firstSpotlightNews">
        <app-featured-list-week [articles]="firstSpotlightNews"></app-featured-list-week>
      </ng-container>
    </div>
    <div class="col-sm-6 order-sm-4 order-first pb-4">

      <ng-container *ngIf="featuredNewsArticle$ | async as featuredNewsArticle">
        <app-featured-article [article]="featuredNewsArticle"></app-featured-article>
      </ng-container>

      <ng-container *ngIf="secondSpotlightNews$ | async as secondSpotlightNews">
        <app-article-list [articles]="secondSpotlightNews"></app-article-list>
      </ng-container>


    </div>
    <div class="col-sm-3 order-sm-4">
      <app-podcast-list></app-podcast-list>
    </div>
  </div>
</div>
